import React from "react";
import {Link, Outlet, Route, Routes} from "react-router-dom";
import {AuthComponents} from "@/lib/_sso";
import RotasNav from "./_components/NavBar";
import Dashboard from "./dashboard";
import AddRota from "./add";
import EditRota from "./edit";
import ScheduleView from "./ScheduleView";
import CalendarView from "./CalendarView";

const RotasIndex = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path={"/add"} element={<AddRota />} />
        <Route path={"/:rota_id/edit"} element={<EditRota />} />
        <Route path={"/schedule"} element={<ScheduleView />} />
        <Route path={"/calendar"} element={<CalendarView />} />
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  );
}
export default RotasIndex;

function Layout() {
  const scope = "teamsite:rotas";

  return (
    <div className="min-h-full">
      <RotasNav />
      <main>
        <AuthComponents.Can scope={scope}>
          <Outlet />
        </AuthComponents.Can>
        <AuthComponents.CanNot scope={scope}>
          <div className={"p-2 text-red-500"}>Access Denied: You do not have permission to access this page.</div>
        </AuthComponents.CanNot>
      </main>
    </div>
  );
}
function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}